export default function TableContainer({ className = "", children }) {
  return (
    <div className={`rounded-2xl border border-white dark:border-slate-900/60 bg-white dark:bg-slate-900/50 overflow-x-auto ${className}`}>
      {children}
    </div>
  );
}
